import { Card } from '@features/ui/components';
import { LinkExternal } from '@features/ui/components/LinkExternal';
import { envConfig } from '@root/envConfig';
import { Trans } from 'next-i18next';
import { ContactsForm } from './ContactsForm';

export const ContactsFormCard = (): JSX.Element => {
  const headerValues = { phone: envConfig.info.phone, email: envConfig.info.mail };

  const header = (
    <div>
      <Trans
        values={headerValues}
        i18nKey="pages.contacts.cardTitle"
        components={[<LinkExternal href={`mailto:${envConfig.info.mail}`} key="email" />]}
      />
    </div>
  );

  return (
    <Card header={header}>
      <ContactsForm />
    </Card>
  );
};
